<template>
        <div id="layoutAuthentication">
            <div id="layoutAuthentication_content">
                <main>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-5">
                                <div class="card" v-if="EmailSuccessResponse">
                                    <div class="card-header">
                                        <h3 class="text-center font-weight-light my-4">Password Recovery</h3>
                                    </div>
                                    <div class="card-body">
                                         <div class="text-center" >
                                         <p>We have sent you an email with a link to reset your password.</p>
                                          <div class="col-md-12">
                                                    <button class="btn btn-outline-success pr-5 pl-5 "
                                                    data-dismiss="modal" aria-hidden="true" @click="resetOk">
                                                        OK
                                                    <div class="spinner-grow" role="status" v-if="loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                    </button>
                                            </div>
                                        <hr />
                                       </div>
                                   </div>
                                  <div class="card-footer">
                                      <div style="width:40px">

                                      </div>
                                  </div>
                                </div>

                                <div class="card shadow-lg border-0 rounded-lg mt-5" v-else>
                                    <div class="card-header"><h3 class="text-center font-weight-light my-4">Password Recovery</h3></div>
                                    <div class="card-body">
                                        <div class="small mb-3 text-muted">Enter your email address and we will send you a link to reset your password.</div>
                                        <form @submit.prevent="send_recovery">
                                            <div class="form-group"><label class="small mb-1" for="inputEmailAddress">Email</label>
                                                <input class="form-control py-4" id="inputEmailAddress" type="email" v-model="email" aria-describedby="emailHelp" placeholder="Enter email address" required/>
                                            </div>
                                            <p v-if="message" class="text-danger">{{ message}}</p>
                                            <div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
                                                <a class="small" href="editor/login" v-if="isEditor">Return to login</a>
                                                <a class="small" href="user/login" v-else>Return to login</a>
                                                <button type="submit" class="btn btn-primary">
                                                    Reset Password
                                                    <div class="spinner-grow" role="status" v-if="loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                    </button>
                                                </div>
                                        </form>
                                    </div>
                                    
                                    <div class="card-footer text-center">
                                        <div class="small">
                                            <a href="user/editor" v-if="isEditor">Need an account? Sign up!</a>
                                            <a href="user/register" v-else>Need an account? Sign up!</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
</template>

<script>
import url from '../URL'

export default {
    data() {
        return {
            email:'',
            message:'',
            EmailSuccessResponse:'',
            loading:false,
            isEditor : false
        }
    },
    methods: {
        send_recovery(){
            this.message = '',
            this.loading = true

            if(!this.email) {
                this.loading = false
                this.message = "Enter Email"
                return ;
            }

          const sendEmail = async() => {

                try {
                  const response = await  this.$http.post(`${this.apiurl}/api/actioncommons/passwordreset/send`,{
                        email : this.email
                    }) 

                    if(response.status === 200) {
                        this.loading = false
                        this.EmailSuccessResponse = true
                    }

                }catch( err ) {
                    
                    if(err.response.status === 404) {
                        this.loading = false;
                        this.message = "Email Incorrect. Check Email and Try Again!."
                    }
                }
          }
          sendEmail()
        }
    },

    computed: {
    apiurl() {
        return url()
    } 
    },
    created() {
        
        if(this.$route.query.next) {
            this.isEditor = true;
        }
    }
}
</script>

<style>

</style>